export default __webpack_public_path__ + "static/media/css-logo.414ad4bc.png";